import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiFacebook, FiInstagram, FiTwitter, FiYoutube, FiMail, FiPhone, FiMapPin } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-neutral-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and Mission */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center">
                <span className="text-white font-bold text-sm">L</span>
              </div>
              <span className="text-xl font-bold">Love 180</span>
            </div>
            <p className="text-neutral-300 mb-4 max-w-md">
              Turning lives toward Jesus 180 degrees at a time through college campus and city outreach throughout Florida.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-neutral-400 hover:text-primary-400 transition-colors">
                <SafeIcon icon={FiFacebook} className="h-5 w-5" />
              </a>
              <a href="#" className="text-neutral-400 hover:text-primary-400 transition-colors">
                <SafeIcon icon={FiInstagram} className="h-5 w-5" />
              </a>
              <a href="#" className="text-neutral-400 hover:text-primary-400 transition-colors">
                <SafeIcon icon={FiTwitter} className="h-5 w-5" />
              </a>
              <a href="#" className="text-neutral-400 hover:text-primary-400 transition-colors">
                <SafeIcon icon={FiYoutube} className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-neutral-300 hover:text-primary-400 transition-colors">About Us</Link></li>
              <li><Link to="/campus-outreach" className="text-neutral-300 hover:text-primary-400 transition-colors">Campus Outreach</Link></li>
              <li><Link to="/city-outreach" className="text-neutral-300 hover:text-primary-400 transition-colors">City Outreach</Link></li>
              <li><Link to="/videos" className="text-neutral-300 hover:text-primary-400 transition-colors">Videos</Link></li>
              <li><Link to="/testimonies" className="text-neutral-300 hover:text-primary-400 transition-colors">Testimonies</Link></li>
              <li><Link to="/events" className="text-neutral-300 hover:text-primary-400 transition-colors">Events</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-neutral-300">
                <SafeIcon icon={FiMail} className="h-4 w-4" />
                <span>info@love180.org</span>
              </div>
              <div className="flex items-center space-x-2 text-neutral-300">
                <SafeIcon icon={FiPhone} className="h-4 w-4" />
                <span>(555) 123-4567</span>
              </div>
              <div className="flex items-center space-x-2 text-neutral-300">
                <SafeIcon icon={FiMapPin} className="h-4 w-4" />
                <span>Florida, USA</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-neutral-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-neutral-400 text-sm">
            © 2024 Love 180 Ministry. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-neutral-400 hover:text-primary-400 text-sm transition-colors">Privacy Policy</a>
            <a href="#" className="text-neutral-400 hover:text-primary-400 text-sm transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;